export declare const ToParam: any;
export default ToParam;
export * from './src/param';
export * from './src/param-item';
